import mergeRoleCapabilityPatch from '@/lib/settings/rolePermissions/mergeRoleCapabilityPatch.js';

const applyPendingRoleCapabilityPatches = ({ capabilities, pendingMutations } = {}) => {
  return (Array.isArray(pendingMutations) ? pendingMutations : []).reduce((currentValue, pendingMutation) => {
    return mergeRoleCapabilityPatch({
      currentValue,
      patchValue: pendingMutation?.capabilities || {}
    });
  }, capabilities || {});
};

export default applyPendingRoleCapabilityPatches;
